import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { APP_CONFIG } from "../../app/app.config";

@Injectable()
export class InvitacionesService {
  private url: string;

	constructor(public http: HttpClient) {}

	
  getInvitacionByCodigo(codigo: string) {
    var headers = new HttpHeaders();
    headers = headers.append("Access-Control-Allow-Origin", "*");

    this.url = APP_CONFIG.apiServer + `/invitacion/${codigo}/`;

    return this.http.get(this.url, {
      headers: headers
    });
  }	
  setInvitacionUsuario(uid: string, sid: string, codigo: string) {
    var headers = new HttpHeaders();
    headers = headers.append("Access-Control-Allow-Origin", "*");
    headers = headers.append("UID", `${uid}`);
    headers = headers.append("SID", `${sid}`);

    this.url = APP_CONFIG.apiServer + `/invitacion/${codigo}/`;

    return this.http
    .post(
      this.url,
      { },
      {
        headers: headers, withCredentials: false,
        responseType: 'json',
        observe: 'body',
        reportProgress: true
      }
    );
  }

}


// WEBPACK FOOTER //
// ./src/services/invitacion/invitacion.service.ts